import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import * as gameAction from "../../redux/game/action";
import * as paramsAction from "../../redux/gameParams/actions";
import * as loaderAction from "../../redux/loader/action";
import _ from "lodash";
import Presenter from "./presenter";
import Viewer from "./viewer";

function Slidekick(props) {
  const gameReducer = _.get(props, "gameReducer");
  const roomObj = _.get(gameReducer, "roomObj");
  const game_state = _.get(roomObj, "game_state");
  const status = _.get(game_state, "status");
  const [component, set_component] = useState();

  useEffect(() => {
    props.setIsLoading(true);
    const mobile_app = _.get(gameReducer, "mobile_app");
    const host_user_id = _.get(roomObj, "host_user_id");
    const current_user_id = _.get(gameReducer, "currentUser.userId");
    if (mobile_app && host_user_id === current_user_id) {
      set_component("presenter");
    } else {
      set_component("viewer");
    }
    props.setIsLoading(false);
  }, []);

  const get_component = () => {
    switch (component) {
      case "presenter":
        return <Presenter status={status} />;
      case "viewer":
        return <Viewer status={status} />;
      default:
        return <></>;
    }
  };

  return <div className="slidekick">{get_component()}</div>;
}

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data)),
    endGame: (data) => dispatch(gameAction.endGame(data)),
    emptyGameData: (data) => dispatch(paramsAction.emptyGameData(data)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Slidekick);
